const SvgVector = (props) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.6523 5.0752V1.0752M13.6523 1.0752H9.65234M13.6523 1.0752L8.31901 6.40853M6.31901 2.40853H4.85234C3.73224 2.40853 3.17218 2.40853 2.74436 2.62652C2.36804 2.81826 2.06208 3.12422 1.87033 3.50055C1.65234 3.92837 1.65234 4.48842 1.65234 5.60853V9.8752C1.65234 10.9953 1.65234 11.5553 1.87033 11.9832C2.06208 12.3595 2.36804 12.6655 2.74436 12.8572C3.17218 13.0752 3.73224 13.0752 4.85234 13.0752H9.11901C10.2391 13.0752 10.7991 13.0752 11.227 12.8572C11.6033 12.6655 11.9093 12.3595 12.101 11.9832C12.319 11.5553 12.319 10.9953 12.319 9.8752V8.40853"
      stroke="#605AFB"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default SvgVector;
